














































import { Component, Vue, Prop } from 'vue-property-decorator'
import { triggerWindowResizeEvent } from '@/utils/util'
import Task from '@/web-task'
import TaskApi from '@/api/task'
const DAI_CHU_LI = '1'
const CHU_LI_ZHONG = '2'
const YI_CHU_LI = '3'
const YI_HU_LVE = '4'

@Component({})
export default class riskSection extends Vue {
	private riskSlideUp: boolean = false
	private interval: any = ''
	private timeoutTimer: any = ''

	@Prop()
	private riskList!: any

	@Prop()
	private taskType!: any

	@Prop()
	private insuranceType!: string

	@Prop({ default: false })
	private isModal!: boolean

	private get list() {
		return this.riskList.map((item: any, key: number) => {
			let stage = item.dealStatus
			let arr = []
			if (stage === DAI_CHU_LI) {
				arr.push({
					title: '忽略',
					handler: this.omit,
				})
				if (item.recommendTaskType) {
					arr.push({
						title: '预约处理',
						handler: this.dealWith,
					})
				}
			} else if (stage === YI_CHU_LI) {
				arr.push({
					title: '查看',
					handler: this.checkDetail,
				})
			} else if (stage === CHU_LI_ZHONG) {
				arr.push({
					title: '取消处理',
					handler: this.cancel,
				})
			}
			return {
				id: item.id,
				riskDesc: item.riskDesc,
				stage: stage,
				handleDesc: item.dealDesc,
				operateArr: arr,
				resultOrderId: item.resultOrderId,
				recommendTaskType: item.recommendTaskType,
				recommendDate: item.recommendDate,
			}
		})
	}

	private riskSlideToggle() {
		this.riskSlideUp = !this.riskSlideUp
		if (this.interval) {
			clearInterval(this.interval)
		}
		if (this.timeoutTimer) {
			clearTimeout(this.timeoutTimer)
		}
		this.interval = setInterval(() => {
			this.$nextTick(() => {
				triggerWindowResizeEvent()
			})
		}, 16)

		// 等待动画时长
		this.timeoutTimer = setTimeout(() => {
			if (this.interval) {
				clearInterval(this.interval)
			}
		}, 500)
	}

	private dealWith(item: any) {
		if (this.isModal) {
			this.$emit('closeModal')
		}
		if (!item.recommendTaskType) {
			return
		}

		let task = new Task({
			propsData: {
				order: {
					taskType: item.recommendTaskType,
					// taskType: '4',
				},
			},
		})
		if (task.isInvestigate) {
			this.$ss.set('riskDisposal', {
				orderId: this.$route.params.orderId,
				taskType: this.taskType,
				insuranceType: this.insuranceType,
				riskDetailId: item.id,
				recommendDate: item.recommendDate,
			})
			this.$router.push('/investigate/addRiskTask')
		} else {
			this.$multiTab.close('/AiiTasks/addResurvey?resurvey=1')
			this.$ss.set(
				'resurveyOrder',
				{
					orderId: this.$route.params.orderId,
					taskType: this.taskType,
					insuranceType: this.insuranceType,
					riskDetailId: item.id,
					recommendDate: item.recommendDate,
				},
				10 * 60 * 1000
			)
			this.$nextTick(() => {
				this.$router.push('/AiiTasks/addResurvey?resurvey=1')
			})
		}
	}

	private checkDetail(item: any) {
		if (this.isModal) {
			this.$emit('closeModal')
		}
		this.$router.push(
			`/CommonAiiTask/TasksDetail/${item.resultOrderId}/${item.recommendTaskType}`
		)
	}

	private omit(item: any) {
		this.$confirm({
			title: '提示',
			content: '是否忽略该风险订单',
			onOk: () => {
				TaskApi.omitRisk(item.id).then(() => {
					this.$emit('getDetail')
				})
			},
		})
	}

	private cancel(item: any) {
		this.$confirm({
			title: '提示',
			content: '是否取消处理该风险订单',
			onOk: () => {
				TaskApi.cancelRiskDeal(item.id).then(() => {
					this.$emit('getDetail')
				})
			},
		})
	}
}
